<template>
  <div>
    <LoadingSpinner v-if="loading"/>

    <ProjectReminderList v-else :project="project" :users="users"/>
  </div>
</template>

<script>
import http from '@/http'
import ProjectReminderList from '../../../../components/Relations/ProjectReminders/Panels/List'
import LoadingSpinner from "../../../../components/Layout/LoadingSpinner.vue";

export default {
  components: {LoadingSpinner, ProjectReminderList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      users: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/users', {page_size: 100}).then(response => {
        this.users = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
